<template>
  <div class="is-flex is-align-items-center" :class="!isInModal ? 'm-t-30' : ''">
    <div id="form" class="is-full-width"></div>
  </div>
</template>

<script>
import { DiagnosticCompletedEventTracking } from '@/modules/typeform/models/segmentevents/DiagnosticCompletedEventTracking';
import { DiagnosticPageViewedEventTracking } from '@/modules/typeform/models/segmentevents/DiagnosticPageViewedEventTracking';
import TypeFormEmbedService from '@/modules/typeform/services/TypeFormEmbedService';
import { ToolsRoutes } from '@/modules/typeform/routes/tools.routes';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TypeFormEmbedForm',
  emits: ['on-end-button-clicked'],
  props: {
    formId: {
      type: String,
      required: true
    },
    isInModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formHeight: this.isInModal ? window.innerHeight : window.innerHeight - 100,
      responseId: null
    };
  },
  methods: {
    onScreenResize(event) {
      this.formHeight = this.isInModal ? event.target.innerHeight : event.target.innerHeight - 100;
      this.refreshWidget();
    },
    refreshWidget() {
      TypeFormEmbedService.createWidget(this.formId, document.querySelector('#form'), {
        inlineOnMobile: true,
        height: this.formHeight,
        onSubmit: ({ formId, responseId }) => {
          this.responseId = responseId;
        },
        onEndingButtonClick: () => {
          this.$router.push({
            name: ToolsRoutes.DIAGNOSTIC_RESULT.name,
            params: { formId: this.formId, id: this.responseId }
          });
          this.$emit('on-end-button-clicked');
          DiagnosticCompletedEventTracking.dispatch(this.formId);
        }
      });
    }
  },
  created() {
    window.addEventListener('resize', this.onScreenResize);
  },
  mounted() {
    this.refreshWidget();
    DiagnosticPageViewedEventTracking.dispatch(this.formId);
  },
  unmounted() {
    window.removeEventListener('resize', this.onScreenResize);
  }
};
</script>
